/**
 * @generated SignedSource<<37e9baaf64cdf818f428732c22dc7850>>
 * @relayHash c06ebbea22a02653ac85643b05c1fe4d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 357cc7aacee360f00037dd80c39f6a65f6be85cbe57876f146faf22e4dcecf9c

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { main_getIssueTransitionByIdRootQuery } from './main_getIssueTransitionByIdRootQuery.graphql';

import isFCFAccessNarrowingEnabled_provider from '@atlassian/jira-relay-provider/src/fcf-its-with-access-narrowing.relayprovider';
import includeEgressOverridesForge_provider from '@atlassian/jira-relay-provider/src/forge-query-include-egress-overrides.relayprovider';
import includeUserAccess_provider from '@atlassian/jira-relay-provider/src/forge-query-include-user-access.relayprovider';
import isNikeChinMigrateMultiSelectEditViewDeprecatedEnabled_provider from '@atlassian/jira-relay-provider/src/nike-chin-migrate-multi-select-edit-view-deprecated.relayprovider';

const node: PreloadableConcreteRequest<main_getIssueTransitionByIdRootQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "357cc7aacee360f00037dd80c39f6a65f6be85cbe57876f146faf22e4dcecf9c",
    "metadata": {},
    "name": "main_getIssueTransitionByIdRootQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcforgequeryincludeuseraccessrelayprovider": includeUserAccess_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcfcfitswithaccessnarrowingrelayprovider": isFCFAccessNarrowingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcforgequeryincludeegressoverridesrelayprovider": includeEgressOverridesForge_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinmigratemultiselecteditviewdeprecatedrelayprovider": isNikeChinMigrateMultiSelectEditViewDeprecatedEnabled_provider
    }
  }
};

export default node;
